<template>
    <div class="order">
        <img src="../../assets/image/banner/banner4.jpg" alt class="fullWidth">
        <div class="main-top main-center">
            <el-tabs type="border-card">
                <!--我要下单-->
                <el-tab-pane :label="$t('order.placeOrder')" class="searchList">
                    <div class="flex flex-space-around">
                        <!--装货港【显示该客户可订舱港口】-->
                        <div class="inputName">
                            <span class="inputName-title">
                                {{$t("order.pol")}}
                            </span>
                            <el-select v-model="search.loadingPort"
                                       :placeholder="$t('common.pleaseSelect')"
                                       clearable
                                       filterable
                                       :filter-method="handleLoadPortFilter"
                                       default-first-option
                                       @focus="optionalPortFocus"
                                       no-data-text="">
                                <el-option v-for="item in loadPortOptions"
                                           :key="item.portCode" :label="item.portCode" :value="item.portCode">
                                    <span style="float: left">{{item.portCode}}</span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                                </el-option>
                            </el-select>
                        </div>
                        <!--卸货港【显示全部基本港口】-->
                        <div class="inputName">
                            <span class="inputName-title">
                                {{$t("order.pod")}}
                            </span>
                            <el-select v-model="search.dischargePort"
                                       :placeholder="$t('common.pleaseSelect')"
                                       clearable
                                       filterable
                                       :filter-method="handleDischargePortFilter"
                                       default-first-option
                                       @focus="basePortFocus"
                                       no-data-text="">
                                <el-option v-for="item in dischargePortOptions"
                                           :key="item.portCode" :label="item.portCode" :value="item.portCode">
                                    <span style="float: left">{{item.portCode}}</span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                                </el-option>
                            </el-select>
                        </div>
                        <!--装货港ETD【默认显示当天】-->
                        <div class="inputName">
                            <span class="inputName-title">
                                {{$t("order.polEtd")}}
                            </span>
                            <el-date-picker v-model="search.ETD" type="date" class="dateInput"
                                            :placeholder="$t('common.pleaseSelectDate')">
                            </el-date-picker>
                        </div>
                        <!--卸货港ETA-->
                        <div class="inputName">
                            <span class="inputName-title">
                                {{$t("order.podEta")}}
                            </span>
                            <el-date-picker v-model="search.ETA" type="date" class="dateInput"
                                            :placeholder="$t('common.pleaseSelectDate')">
                            </el-date-picker>
                        </div>
                        <el-button type="primary" icon="el-icon-search"
                                   @click="handleDemand">
                            {{searchButton}}
                        </el-button>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <!--使用说明-->
            <div class="explainBox" v-show="explainBoxShow">
                <div class="explainBox-title font-weight">{{$t("order.note1")}}</div>
                <p>{{$t("order.note2")}}</p>
                <p>{{$t("order.note3")}}</p>
                <p class="pTitle">{{$t("order.note4")}}</p>
                <p>{{$t("order.note5")}}</p>
                <p>{{$t("order.note6")}}</p>
                <p class="pTitle">{{$t("order.note7")}}</p>
                <p>{{$t("order.note8")}}</p>
                <p class="pTitle">{{$t("order.note9")}}</p>
                <p>{{$t("order.note10")}}</p>
                <p>{{$t("order.note11")}}</p>
            </div>
            <!--查询结果-->
            <div class="tableBox" v-show="!explainBoxShow">
                <resultBar></resultBar>
                <!--船期数据表格-->
                <div class="mainTable">
                    <el-table :data="tableData" style="width: 100%"
                              max-height="600"
                              :header-cell-style="{background:'#E9E9E9',height:'45px',padding:0}"
                              :row-style="{height:'40px'}" :cell-style="{padding:'0px'}"
                              highlight-current-row @row-click="rowClick" :empty-text="$t('common.noData')">
                        <!--序号-->
                        <el-table-column prop="rowNo" label="NO." min-width="50" align="center" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span class="grayColor">{{scope.row.rowNo}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="voyagePlanId" label="船期ID" v-if=false></el-table-column>
                        <!--船名-->
                        <el-table-column prop="vesselName" :label="$t('order.vesselName')" min-width="190"
                                         align="center" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span class="blueColor">{{scope.row.vesselName}}</span>
                            </template>
                        </el-table-column>
                        <!--航次-->
                        <el-table-column prop="voyage" :label="$t('order.voyage')" min-width="80"
                                         align="center"
                                         show-overflow-tooltip></el-table-column>
                        <!--路线-->
                        <!--<el-table-column prop="route" label="路线"
                                         min-width="120" align="center"
                                         show-overflow-tooltip></el-table-column>-->
                        <!--码头-->
                        <el-table-column prop="polTerminalCode" :label="$t('order.polTerminalCode')"
                                         min-width="100" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <!--POL ETA-->
                        <el-table-column prop="polEta" :label="$t('order.polEta')" min-width="100"
                                         align="center"
                                         show-overflow-tooltip></el-table-column>
                        <!--POL ETD-->
                        <el-table-column prop="polEtd" :label="$t('order.polEtd2')" min-width="100"
                                         align="center"
                                         show-overflow-tooltip></el-table-column>
                        <!--POD ETA-->
                        <el-table-column prop="podEta" :label="$t('order.podEta2')" min-width="100"
                                         align="center"
                                         show-overflow-tooltip></el-table-column>
                        <!--航行时间-->
                        <el-table-column prop="underway" :label="$t('order.underway')" min-width="80"
                                         align="center"
                                         show-overflow-tooltip></el-table-column>
                        <!--航线-->
                        <el-table-column prop="serviceLineCode" :label="$t('order.serviceLineCode')"
                                         min-width="80" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <!--订舱功能按钮-->
                        <el-table-column label="" align="center">
                            <template slot-scope="scope">
                                <el-button class="orange-button"
                                           @click="gotoBookingSpace(scope.row)">
                                    {{bookingButton}}
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!--pagination分页条-->
                <div class="pagination">
                    <div>
                        <el-pagination background layout="total,sizes,slot,prev, pager, next"
                                       max-height="600"
                                       :page-size="pageSize" :pager-count="pageCount"
                                       :page-sizes="[10, 20, 30, 50]" :total="total"
                                       :current-page="pageNum"
                                       @size-change="handleSizeChange"
                                       @current-change="handleCurrentChange">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!--页面底部组件-->
        <div class="footerSpan">
            <span></span>
        </div>
    </div>
</template>
<script>
    import resultBar from '../../components/resultBar'

    export default {
        name: 'order',
        computed: {
            /*查询按钮*/
            searchButton() {
                return this.$t("common.searchButton");
            },
            /*订舱按钮*/
            bookingButton() {
                return this.$t("common.bookingButton");
            },
        },
        components: {
            resultBar,
        },
        data() {
            return {
                isClick: false,
                //查询参数
                search: {
                    loadingPort: "",        //装货港
                    dischargePort: "",      //卸货港
                    ETD: this.formatDate(), //ETD
                    ETA: "",
                },
                loadPortOptions: [],        //装货港下拉选项
                dischargePortOptions: [],   //卸货港下拉选项
                allLoadPorts: [],        // 完整装货港列表
                allDischargePorts: [],   // 完整卸货港列表
                explainBoxShow: true,       //是否显示使用说明栏
                tableData: [],              //船期表格数据
                pageCount: 5,               //船期表格-数据总页数
                pageNum: 1,                 //船期表格-当前页码
                pageSize: 10,               //船期表格-每页显示记录数
                total: 0,                   //船期表格-查询出总记录数
                voyagePlan: ""              //记录当前鼠标点击选中的船期表格中的记录
            }
        },
        methods: {
            /************************************ 按钮点击事件 ************************************
             * 查询按钮点击事件
             */
            handleDemand() {
                //装货港和卸货港为必选
                if (this.search.loadingPort === "") {
                    this.showMessage(false, this.$t("message.loadingPortValidate"), "warning");
                    return
                }
                if (this.search.dischargePort === "") {
                    this.showMessage(false, this.$t("message.dischargePortValidate"), "warning");
                    return
                }

                if (this.isClick) {
                    return;
                }
                this.isClick = true;

                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.searching'),             // 加载动画的文字
                    spinner: 'el-icon-loading',                     // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                    target: document.querySelector(".searchList")   // 设置加载动画区域
                });
                let that = this;
                //调用后端船期查询API
                this.axios({
                    method: 'post',
                    url: '/api/voyagePlan/getVoyagePlanList',
                    data: {
                        pol: this.search.loadingPort,
                        pod: this.search.dischargePort,
                        polEtdFrom: this.search.ETD === "" ? "" : this.formatDate(
                            {date: this.search.ETD, formatStr: 'yyyy-MM-dd'}
                        ),
                        podEtaFrom: this.search.ETA === "" ? "" : this.formatDate(
                            {date: this.search.ETA, formatStr: 'yyyy-MM-dd'}
                        ),
                        pageNo: this.pageNum,
                        pageCount: this.pageSize
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    //成功响应,关闭进度条
                    that.loadingtuo.close();
                    if (response.data.backCode === "200") {
                        //关闭使用说明,显示船期数据表格
                        this.explainBoxShow = false;
                        this.tableData = JSON.parse(response.data.object);
                        //设置pagination分页数据
                        this.total = this.tableData.length === 0 ? 0 : this.tableData[0].maxRowNo;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    //请求成功,查询按钮设置为未点击状态,允许再次请求
                    this.isClick = false;
                }).catch(error => {
                    //请求失败,关闭进度条
                    that.loadingtuo.close();
                    //请求失败,查询按钮设置为未点击状态,允许再次请求
                    this.isClick = false;
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 订舱按钮点击事件【路由跳转】携带选中船期数据到订舱新增页面
             */
            gotoBookingSpace(row) {
                // this.$router.push({
                //     name: "order/bookingSpace",
                //     params: {voyagePlanInfo: row, portCode: this.search.dischargePort}
                // });
                var route = this.$router.resolve({
                    name: 'order/bookingSpace',
                });
                // 将传递参数存到session中
                sessionStorage.setItem("PASSING_PARAMETERS", JSON.stringify(row));
                sessionStorage.setItem("PASSING_PARAMETERS_1", this.search.dischargePort);
                // 打开订舱详情页面
                window.open(route.href, '_blank')
            },

            /************************************ 船期表格数据行点击事件 ************************************
             * 某行被点击时,记录该行船期数据,用于跳转到订舱编辑页面作为携带参数
             */
            rowClick(row) {
                this.voyagePlan = JSON.stringify(this.tableData[row.rowNo - 1]);
            },

            /************************************ 分页条 ************************************
             * 船期数据表格分页条
             */
            handleSizeChange(val) {//每页显示数量改变
                this.pageSize = val;
                //每页显示数据条数改变后,从第一页开始显示
                this.pageNum = 1;
                this.handleDemand();
                this.$emit("backTop");
            },
            handleCurrentChange(val) {//当前页码改变事件
                this.pageNum = val;
                this.handleDemand();
                this.$emit("backTop");
            },

            /************************************ 基础数据查询 ************************************
             * 装货港下拉数据查询:显示当前账号允许下单的港口
             */
            optionalPortFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/port/getOptionalPortList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.allLoadPorts = response.data.object;
                    _this.loadPortOptions = [..._this.allLoadPorts]; // 初始显示全部
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 卸货港下拉数据查询:显示全部港口类型=港口的数据
             */
            basePortFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/port/getAllBasePortList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.allDischargePorts = response.data.object;
                    _this.dischargePortOptions = [..._this.allDischargePorts];
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },

            /************************************ 页面初始化 ************************************
             * 初始化基础数据
             */
            initCombos() {
                this.optionalPortFocus();
                this.basePortFocus();
            },

            handleLoadPortFilter(query) {
              if (!query) {
                this.loadPortOptions = [...this.allLoadPorts];
                return;
              }
              const q = query.toLowerCase();
              this.loadPortOptions = this.allLoadPorts.filter(item => {
                return (
                    (item.portCode && item.portCode.toLowerCase().includes(q)) ||
                    (item.portNameCn && item.portNameCn.toLowerCase().includes(q)) ||
                    (item.portName && item.portName.toLowerCase().includes(q))
                );
              });
            },

            handleDischargePortFilter(query) {
            if (!query) {
              this.dischargePortOptions = [...this.allDischargePorts];
              return;
            }
            const q = query.toLowerCase();
            this.dischargePortOptions = this.allDischargePorts.filter(item => {
              return (
                  (item.portCode && item.portCode.toLowerCase().includes(q)) ||
                  (item.portNameCn && item.portNameCn.toLowerCase().includes(q)) ||
                  (item.portName && item.portName.toLowerCase().includes(q))
              );
            });
          },
        },
        mounted() {
            this.initCombos();
            this.$parent.updateHeaderAside();
        },
    }
</script>
<style lang="scss" scoped>
    @import "../../assets/scss/base.scss";
    @import "../../assets/scss/public.scss";

    .order {
        padding-bottom: 20px;
    }

    .eL-tabs {
        z-index: 100;
        margin-top: -40px;
    }

    .inputName {
        flex: 1;
        margin: 0 5px;
    }

    .explainBox {
        background: #e8eff7;
        border: 1px solid #e8e8e8;
        margin: 20px 0;
        padding: 0 16px 20px 16px;
    }

    .explainBox-title {
        color: $colorC;
        padding: 0 18px;
        border-bottom: 2px solid $colorC;
        line-height: 43.5px;
    }

    .pTitle {
        color: rgb(218, 131, 46);
        font-size: 17px;
    }

    .tableBox {
        margin: 20px 0;
    }

    //table每行border
    // /deep/ .el-table .el-table__cell.is-center{
    //   border-bottom-width: 3px;
    // }
</style>